import React, { useState, useMemo } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  useStripe,
  useElements,
  Elements,
} from '@stripe/react-stripe-js';
import { useReportAuth } from '../context/ReportAuthContext';
import { manualcardcreatePaymentIntent, completePayment } from '../services/api';
import { useNavigate, Link } from 'react-router-dom';
// ---------------------------------------------------------------------------
// 1. Load Stripe ONCE outside of any component render to avoid re-creating
//    the Stripe object on every render. Replace with your own publishable key
//    (use an env var in production: process.env.REACT_APP_STRIPE_PK).
// ---------------------------------------------------------------------------
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_test_51Oe7xRFlJQ9qioSs6rief539WY829vcm0W24lnKiettyueuENiQQvEMi8LwY3QxFO1fAIdkdELRhegIR7LVZGBy600UPsHuYKh');

// ---------------------------------------------------------------------------
// 2. Shared options for the Stripe Elements. Styling the iframes is done
//    via the `style` object — you cannot target them with regular CSS.
// ---------------------------------------------------------------------------
const ELEMENT_OPTIONS = {
  style: {
    base: {
      fontSize: '16px',
      color: '#1a1a1a',
      fontFamily: '"Inter", system-ui, -apple-system, sans-serif',
      fontSmoothing: 'antialiased',
      '::placeholder': { color: '#9ca3af' },
      iconColor: '#6b7280',
    },
    invalid: {
      color: '#dc2626',
      iconColor: '#dc2626',
    },
  },
  showIcon: true, // shows the card brand icon inside CardNumberElement
};

// ---------------------------------------------------------------------------
// 3. The actual checkout form. Must be a CHILD of <Elements>, otherwise the
//    useStripe / useElements hooks return null.
// ---------------------------------------------------------------------------
function CheckoutForm({ amount = 400, currency = 'aud', data }) {
  console.log('props plate: ' + data.plate);
  const { reportType, plate, state, subtotal } = data;
  const stripe = useStripe();
  const elements = useElements();
  const {setCustomerInfo, saveReportToken} = useReportAuth();
  const [cardholderName, setCardholderName] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [postalCode, setPostalCode] = useState('');
  const [phone, setPhone] = useState('');

  const [processing, setProcessing] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [succeeded, setSucceeded] = useState(false);
  const [accepted,  setAccepted]  = useState(false);
  const navigate = useNavigate();

  // Track per-field validity so we can enable/disable the submit button
  // and show inline error messages.
  const [fieldErrors, setFieldErrors] = useState({
    cardNumber: null,
    cardExpiry: null,
    cardCvc: null,
  });
  const [fieldComplete, setFieldComplete] = useState({
    cardNumber: false,
    cardExpiry: false,
    cardCvc: false,
  });

  const allFieldsComplete = useMemo(
    () =>
      Object.values(fieldComplete).every(Boolean) &&
      cardholderName.trim().length > 0 &&
      email.trim().length > 0,
    [fieldComplete, cardholderName, email]
  );

  const handleElementChange = (field) => (event) => {
    setFieldErrors((prev) => ({
      ...prev,
      [field]: event.error ? event.error.message : null,
    }));
    setFieldComplete((prev) => ({ ...prev, [field]: event.complete }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg(null);

    if (!stripe || !elements) {
      // Stripe.js hasn't loaded yet.
      return;
    }

    setProcessing(true);

    // -----------------------------------------------------------------------
    // OPTION A — Create a PaymentMethod on the client and send it to your
    // server, where you'd attach it to a PaymentIntent / Subscription /
    // SetupIntent. This is the most common flow when you don't yet have a
    // PaymentIntent client_secret on the page.
    // -----------------------------------------------------------------------
    const cardNumberElement = elements.getElement(CardNumberElement);

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: cardNumberElement, // CardNumberElement implicitly includes expiry + cvc
      billing_details: {
        name: cardholderName,
        email,
        address: { postal_code: postalCode },
      },
    });
    
    console.log('stripe.createPaymentMethod()');

    if (error) {
      setErrorMsg(error.message);
      setProcessing(false);
      return;
    }

    try {


        console.log('BEGIN:const res_manualcard = await manualcardcreatePaymentIntent({');
        console.log('paymentMethod.id :'+ paymentMethod.id);
        console.log('amount :'+ amount);
        console.log('currency :'+ currency);
        
              //const data = await createPaymentIntent({
                //reportType,
                //plate,
                //state,
                //email,
                //firstName,
                //lastName,
              //});

          //const res_manualcard = await manualcardcreatePaymentIntent({
          //payment_method_id: paymentMethod.id,
          //amount,
          //currency
          //});

          const res_manualcard = await manualcardcreatePaymentIntent({
          payment_method_id: paymentMethod.id,
          reportType,
          plate,
          state,
          email,
          firstName,
          lastName
          });

          console.log('END:const res_manualcard = await manualcardcreatePaymentIntent({');

          //const data_manualcard = await res_manualcard.json();
          
          console.log('STRIPECHECKOU.jsx - res_manualcard :'+ JSON.stringify(res_manualcard));
          console.log('STRIPECHECKOU.jsx - res_manualcard.clientSecret :'+ res_manualcard.clientSecret);
          console.log('STRIPECHECKOU.jsx - res_manualcard.paymentIntentId :'+ res_manualcard.paymentIntentId);

          if (res_manualcard.paymentIntentId && res_manualcard.clientSecret) {
        // -------------------------------------------------------------------
        // OPTION B — 3D Secure / SCA flow. Server returned a client secret
        // because the card needs additional authentication.
        // -------------------------------------------------------------------
            //const { error: confirmError } = await stripe.confirmCardPayment(
              //res_manualcard.clientSecret
            //);

            //const { error, paymentIntent } = await stripe.confirmCardPayment(
                //res_manualcard.clientSecret,
                //{
                    //payment_method: paymentMethod,
                //}
            //);
            
            //if (confirmError) {
                //setErrorMsg(confirmError.message);
                //setProcessing(false);
                //return;
            //}

            console.log('email: ' + email);
            console.log('firstName: ' + firstName);
            console.log('lastName: ' + lastName);
            console.log('phone: ' + phone);
            console.log('BEGIN: setCustomerInfo({ email, firstName, lastName, phone });');
            setCustomerInfo({ email, firstName, lastName, phone });
            console.log('END: setCustomerInfo({ email, firstName, lastName, phone });');

            const result = await completePayment({
                paymentIntentId: res_manualcard.paymentIntentId,
                reportType,
                plate,
                state,
                email,
            });

                console.log('completePayment()');

            saveReportToken(result.token, result.orderId);

            console.log('saveReportToken()');
            //setSucceeded(true);

            //saveReportToken(result.token, result.orderId);

            navigate('/Processing');

        }

    } catch (err) {
      setErrorMsg('Network error. Please try again.');
    } finally {
      setProcessing(false);
    }
  };

  if (succeeded) {
    return (
      <div className="success-card">
        <div className="success-icon">✓</div>
        <h2>Payment successful</h2>
        <p>A receipt has been sent to {email}.</p>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="checkout-form" noValidate>






        <div className="form-section">
            <h3 className="form-section-title">Contact Information</h3>
            <div className="form-group">
            {/* --- Customer details (plain inputs, NOT Stripe Elements) --- */}
                <div className="field">
                    <label htmlFor="firstname">First Name</label>
                    <input
                    id="firstname"
                    type="text"
                    autoComplete="given-name"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    placeholder="First Name"
                    required
                    />
                </div>
            </div>
      
            <div className="form-group">
                <div className="field">
                    <label htmlFor="lastname">Last Name</label>
                    <input
                    id="lastname"
                    type="text"
                    autoComplete="family-name"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    placeholder="Last Name"
                    required
                    />
                </div>
            </div>
        
            <div className="form-group">
                <div className="field">
                    <label htmlFor="phone">Phone Number</label>
                    <input
                    id="phone"
                    type="text"
                    autoComplete="tel"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    placeholder="Phone number"
                    required
                    />
                </div>
            </div>

            <div className="form-group">
                <div className="field">
                    <label htmlFor="email">Email</label>
                    <input
                    id="email"
                    type="email"
                    autoComplete="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@example.com"
                    required
                    />
                </div>
            </div>

            <div className="form-group">
                <div className="field">
                    <label htmlFor="postal">Postal code</label>
                    <input
                        id="postal"
                        type="text"
                        autoComplete="postal-code"
                        value={postalCode}
                        onChange={(e) => setPostalCode(e.target.value)}
                        placeholder="Your Postal Code"
                    />
                </div>
            </div>
        </div>


        
        <div className="form-section">
            <h3 className="form-section-title">Payment Method</h3>
            <div className="form-group">
                <div className="field">
                    <label htmlFor="name">Cardholder name</label>
                    <input
                    id="name"
                    type="text"
                    autoComplete="cc-name"
                    value={cardholderName}
                    onChange={(e) => setCardholderName(e.target.value)}
                    placeholder="Name on card"
                    required
                    />
                </div>
            </div>
        </div>

        <div className="form-section">
            {/* --- Stripe Elements (each one is a hosted iframe) --- */}
            <div className="form-group">
                <div className="field">
                    <label htmlFor="card-number">Card number</label>
                    <div
                    className={`stripe-input ${
                        fieldErrors.cardNumber ? 'has-error' : ''
                    }`}
                    >
                    <CardNumberElement
                        id="card-number"
                        options={ELEMENT_OPTIONS}
                        onChange={handleElementChange('cardNumber')}
                    />
                    </div>
                    {fieldErrors.cardNumber && (
                    <p className="field-error">{fieldErrors.cardNumber}</p>
                    )}
                </div>
            </div>

            <div className="form-group">
                    <div className="field">
                    <label htmlFor="card-expiry">Expiration</label>
                    <div
                        className={`stripe-input ${
                        fieldErrors.cardExpiry ? 'has-error' : ''
                        }`}
                    >
                        <CardExpiryElement
                        id="card-expiry"
                        options={ELEMENT_OPTIONS}
                        onChange={handleElementChange('cardExpiry')}
                    />
                    </div>
                    {fieldErrors.cardExpiry && (
                        <p className="field-error">{fieldErrors.cardExpiry}</p>
                    )}
                </div>
            </div>

            <div className="form-group">
                <div className="field">
                <label htmlFor="card-cvc">CVC</label>
                <div
                    className={`stripe-input ${
                    fieldErrors.cardCvc ? 'has-error' : ''
                    }`}
                >
                    <CardCvcElement
                    id="card-cvc"
                    options={ELEMENT_OPTIONS}
                    onChange={handleElementChange('cardCvc')}
                    />
                </div>
                {fieldErrors.cardCvc && (
                    <p className="field-error">{fieldErrors.cardCvc}</p>
                )}
                </div>
            </div>

            



            {/* Terms */}
            <div className="form-section">
                <label className="checkbox-label">
                <input
                    type="checkbox"
                    checked={accepted}
                    onChange={(e) => setAccepted(e.target.checked)}
                />
                <span>
                    I agree to the{' '}
                    <Link to="/terms-conditions" target="_blank">Terms &amp; Conditions</Link>
                    {' '}and{' '}
                    <Link to="/privacy-policy" target="_blank">Privacy Policy</Link>
                </span>
                </label>
            </div>


            {errorMsg && <div className="form-error">{errorMsg}</div>}

            <button
                type="submit"
                className="btn btn-primary btn-large btn-block"
                disabled={!stripe || processing || !allFieldsComplete || !accepted}
            >
                {processing ? (
                <span className="spinner" aria-label="Processing" />
                ) : (
                `Pay ${(subtotal).toLocaleString('en-US', {
                    style: 'currency',
                    currency: currency.toUpperCase(),
                })}`
                )}
            </button>
      </div>

      <p className="secure-note">
        🔒 Payments are securely processed by Stripe. Your card details never
        touch our servers.
      </p>
    </form>
  );
}

// ---------------------------------------------------------------------------
// 4. Top-level wrapper — must render <Elements> so the hooks work inside.
// ---------------------------------------------------------------------------
export default function StripeCheckout(props) {
  return (
    <Elements stripe={stripePromise}>
      <CheckoutForm {...props} />
    </Elements>
  );
}